import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-bootstrap'
import Plyr from 'react-plyr'
import PlusIcon from './PlusIcon'
import './intro.css'

const Intro = () => (
  <Grid className="intro">
    <Row>
      <Col xs={12} md={6}>
        <h2>
          Čo robili vaši 21.&nbsp;augusta&nbsp;1968?
          <br />
          <Link to="/pridat">Pridaj príbeh…</Link>
        </h2>
        <PlusIcon />
      </Col>
      <Col xsHidden smHidden md={6}>
        <Plyr type="youtube" videoId="XvOFEtqyEJQ" />
      </Col>
    </Row>
  </Grid>
)

export default Intro



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js